module.exports = __webpack_public_path__ + "img/load.e106115e.png";